import { Button, Form, Input, message, notification, Select, Upload } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { DeleteOutlined, DownloadOutlined, EditOutlined, FileDoneOutlined } from '@ant-design/icons'
import liracrypt from '../../components/Liracrypt/liracrypt';
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from 'react-redux';

const FileController = ({
    form,
    label,
    name,
    labelCol,
    required,
    data,
    height,
    disabled
}) => {
    const urlCode = useSelector(state => state.urlCode);
    const [file, setFile] = useState();
    const [isResponsefile, setIsRespfile] = useState(false);
    const fileInputRef = useRef();
    const [currentValue, setCurrentValue] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (currentValue === '') {
            setFile(null);
        }
    }, [currentValue]);


    const handleDrop = (e) => {
        e.nativeEvent.preventDefault()
        if (!e) return;
        const files = e.nativeEvent.dataTransfer.files;
        if (!files[0]) return;
        if (files[0].type.includes('image/')) {
            setFile(files[0]);
            form.setFieldsValue({ [name]: files[0] });
        } else {
            notification.error({ message: 'Please Select image file only' })
        }
    };

    const getSelectedFile = (e) => {
        if (!e.target.files[0]) return;
        const fileSizeBytes = e.target.files[0].size; // bytes
        const fileSizeMB = fileSizeBytes / (1024 ** 2);
        let validation = {
            ...data.validate || {
                maxSize: 1,
                errorMessage: 'File size should not be more than 1 mb'
            }
        }
        if (fileSizeMB > validation.maxSize) {
            return message.error(validation.errorMessage || 'File size is large');
        }
        setFile(e.target.files[0]);
        form.setFieldsValue({ [name]: e.target.files[0] });
    }

    const resetFile = () => {
        form.setFieldsValue({ [name]: isResponsefile ? null : '' });
        fileInputRef.current.value = '';
        setFile(null)
    };

    useEffect(() => {
        if (data.hasFile) {
            setFile({ name: data.params.name });
            form.setFieldsValue({ [name]: 'noChange' });
            // setLoading(true);
            // liracrypt.get(data.api, data.params)
            //     .then(response => {
            //         setFile(response.data.data);
            //         setIsRespfile(true);
            //         form.setFieldsValue({ [name]: 'noChange' });
            //         setLoading(false);
            //     })
            //     .catch(err => {
            //         console.error(err);
            //         setLoading(false);
            //     })
        }
    }, []);


    return (
        <>
            <Form.Item
                getValueProps={(e) => setCurrentValue(e)}
                name={name}
                labelCol={{ span: labelCol || 8 }}
                style={{ cursor: disabled ? 'not-allowed' : 'normal' }}
                label={label}
                initialValue=""
                rules={[
                    {
                        required: required,
                        message: 'Please add file',
                    },
                ]}
            >

                {
                    loading ?
                        <>
                            <LoadingOutlined
                                style={{ fontSize: 80, color: "#dc3545" }}
                                spin
                            />
                        </> :
                        file ? (
                            <div className='uploaded-img'>
                                <div className={"img"} style={{ minHeight: height, textAlign: 'center', flexDirection: 'column', display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>
                                    {/* <img
                                        src={typeof (img) === 'string' ? img : URL.createObjectURL(img)}
                                    /> */}
                                    {/* <FileDoneOutlined style={{ color: '#ffffff', fontSize: 35 }} /> */}
                                    <p style={{ color: '#ffffff', fontSize: 20, marginBottom: 0, overflow: 'hidden', width: '100%' }}>{file.name}</p>
                                    {
                                        data.desc ?
                                            <p style={{ color: '#ffffff', fontSize: 12, marginBottom: 0 }}>{data.desc}</p> : <></>
                                    }
                                </div>
                                {
                                    !disabled && (
                                        <div className='img-delete-icon file' style={{ top: 0, padding: 5 }}>
                                            <div style={{ marginRight: 20 }} onClick={() => { fileInputRef.current.click() }}>
                                                <span>
                                                    <EditOutlined className="img-edit" />
                                                </span>
                                            </div>
                                            <div style={{ marginRight: 20 }} onClick={resetFile}>
                                                <span>
                                                    <DeleteOutlined className="img-trash" />
                                                </span>
                                            </div>
                                            <a target='_blank' href={`${process.env.REACT_APP_API_ENDPOINT}${data.api}?${new URLSearchParams(data.params)}&token=${localStorage.getItem("token")}&urlCode=${urlCode}`} style={{ marginRight: 20 }}>
                                                <span>
                                                    <DownloadOutlined className="img-edit" />
                                                </span>
                                            </a>
                                        </div>
                                    )
                                }

                            </div>
                        ) :
                            <div onDragOver={e => e.preventDefault()} onDrop={handleDrop} onClick={() => { fileInputRef.current.click() }} className='upload-image' style={{ minHeight: height, pointerEvents: disabled ? 'none' : '' }}>
                                <Button type='link' style={{ color: ' #777777', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                    <span style={{ lineHeight: 'normal' }}>Click To Upload</span>
                                    {
                                        data.desc ?
                                            <span style={{ fontSize: 12 }}>{data.desc}</span> : <></>
                                    }
                                </Button>
                            </div>
                }
            </Form.Item>
            <input className='hidden-input' ref={fileInputRef} type="file" style={{ visibility: 'hidden' }} onChange={getSelectedFile} />
        </>
    )
};

export default FileController;